import React, { Component } from 'react'
import { connect } from 'react-redux'
import {QuizzRankingStyle} from './../../styles'
import {Link} from 'react-router-dom'
import Router from './../../services/Router'
import { fetchPage } from '../../services/ApiController'

class QuizzRanking extends Component {


  render() {
    const { quizz, total } = this.props
    const x = parseInt(quizz) / parseInt(total) * 100
    return (
      <div className={`quizz-ranking ${QuizzRankingStyle(x)} `}>
        <div className="quizz-ranking-label label">
          Quizz taken
        </div>
        <div className="quizz-ranking-number">
          <span className="number">{ quizz }</span>
          <span className="all">/{ total }</span>
        </div>
        <div className="quizz-ranking-link">
          <Link to={Router.hubQuizz.path} className="link">See all Quizzes</Link>
        </div>
      </div>
    )
  }
}

export default connect(
  ({ Session }) => ({
    quizz: Session.challenge.quizz,
    total: Session.challenge.quizzTotal
  })
)(QuizzRanking)


// WEBPACK FOOTER //
// ./src/components/Challenge/QuizzRanking.js